// extracted by mini-css-extract-plugin
module.exports = {"showimage":"showimage_showimage__3O05o","dialog":"showimage_dialog__3_t7l","myoverlay":"showimage_myoverlay__3oAr4","image":"showimage_image__2fy-k"};